import { render, staticRenderFns } from "./event-detail-download.vue?vue&type=template&id=938821e2&scoped=true&"
import script from "./event-detail-download.vue?vue&type=script&lang=js&"
export * from "./event-detail-download.vue?vue&type=script&lang=js&"
import style0 from "./event-detail-download.vue?vue&type=style&index=0&id=938821e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "938821e2",
  null
  
)

export default component.exports